import { PUBLIC_ASSETS } from '@/configs/public-assets.config';

interface ErrorLayoutProps {
  title: string;
  description: string;
  illustration?: string;
  children?: React.ReactNode;
}

export default function ErrorLayout({
  title,
  description,
  illustration,
  children,
}: ErrorLayoutProps) {
  return (
    <>
      <div className="relative h-screen bg-linear-0 from-secondary to-accent grid place-items-center overflow-hidden">
        {/* background element */}
        <div className="absolute top-0 left-0 size-full flex flex-col justify-between">
          <img className="w-full" src={PUBLIC_ASSETS.bgTextureSquare} alt="" />
          <img className="w-full" src={PUBLIC_ASSETS.bgImageErrorPage} alt="" />
        </div>

        {/* main content */}
        <div className="relative z-10 flex w-full flex-col items-center justify-center text-center gap-6 md:gap-10 max-w-lg px-6">
          <img
            className="w-40 md:w-48"
            src={PUBLIC_ASSETS.nutriseeLogo}
            alt="logo Nutrisee"
          />
          {illustration && (
            <img
              className="w-full max-h-80 object-center object-contain"
              src={illustration}
              alt={title}
            />
          )}
          <div className="space-y-2">
            <h2 className="font-heading text-2xl font-bold">{title}</h2>
            <p className="font-light text-lg text-gray-500">{description}</p>
          </div>
          {children}
        </div>
      </div>
    </>
  );
}
